import mapperIcon from '../../utils/mappers/mapper-icon'
import { mapperModuleMedia, mapperModuleNavigationLink } from '../../modules/mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * BlockCallToAction
 */
export const mapperBlockCallToActionWithMedia = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  const image = mapperModuleMedia(data.image, options.imageOptions)
  return {
    id: data.sys?.id,
    contentType: data.contentType,
    icon: mapperIcon(data.icon),
    title: data.title || '',
    text: data.text || '',
    image,
    link: mapperModuleNavigationLink(data.link, options.getUrl)
  }
}
